export default __webpack_public_path__ + "static/media/laugh.32ac52b5.png";